var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{attrs:{"dbList":this.dbList,"indexList":this.indexList,"listLimit":this.listLimit}})
}
var staticRenderFns = []

export { render, staticRenderFns }